import React from 'react';
import cn from 'classnames';
import { TabLink as NextNavLink } from '@framework/router/Next/Link';
import FeaturesComponent from '@framework/ui/Pages/Landing/Sections/Features';
import Section from '@framework/ui/Pages/Landing/Sections/Section';
import SectionContainer from '@framework/ui/Pages/Landing/Sections/SectionContainer';
import SectionHeader from '@framework/ui/Pages/Landing/Sections/SectionHeader';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';
import { featuresTabsList } from '../../Features/tabs';

import baseStyles from '@/dataroom/ui/components/Landing/dealvdr/tenantDealvdrStyles.module.scss';
import styles from './features.module.scss';

const Features = () => (
  <Section padding="top">
    <SectionContainer>
      <SectionHeader
        title="Execute with confidence on DealVDR"
        description="DealVDR is easier to set up and manage with all the functionality you need to get your files and users into and out of the data room as quickly and securely as possible."
        maxWidth={ 770 }
      />
    </SectionContainer>
    <SectionContainer size="large" narrow>
      <FeaturesComponent
        autoplay
        actionButton={ (
          <NextNavLink
            to="/features"
            dataTest="exploreOurFeatures"
          >
            <Button
              variant={ ButtonVariantType.action }
              className={ cn(baseStyles.actionButton, styles.exploreButton) }
              title="Explore & Compare Our Features"
              dataTest="exploreOurFeaturesButton"
            />
          </NextNavLink>
        ) }
        tabsList={ featuresTabsList }
      />
    </SectionContainer>
  </Section>
);

export default Features;
